import { Button, Spinner } from '@crm/ui';
import { CheckCircle2, MessageSquare, RefreshCw } from 'lucide-react';
import { StatusHeader } from '@/components';
import { type Unit, useRefreshWhatsapp } from '@/modules/company';
import type { PhoneLine } from '../api';
import { andamentoDaUnidade, situacaoDaUnidade } from './unit-status';
import { WhatsappProgress } from './whatsapp-progress';

interface WhatsappSummaryProps {
  unit: Unit;
  linha: PhoneLine | null;
  pending?: boolean;
}

export function WhatsappSummary({ unit, linha, pending }: WhatsappSummaryProps) {
  const atualizar = useRefreshWhatsapp();

  const situacao = situacaoDaUnidade(unit, linha);
  const andamento = andamentoDaUnidade(unit, linha);
  const numero = unit.whatsappFrom ?? linha?.phoneNumber ?? null;
  const conectada = situacao.setup === 'conectada';

  return (
    <div className="space-y-4">
      <StatusHeader
        icon={
          pending ? (
            <Spinner />
          ) : conectada ? (
            <CheckCircle2 className="h-5 w-5" />
          ) : (
            <MessageSquare className="h-5 w-5" />
          )
        }
        tone={situacao.tone}
        title={conectada ? 'WhatsApp ativo' : (numero ?? unit.name)}
        detail={
          pending
            ? 'Registrando o numero no WhatsApp.'
            : conectada
              ? `As mensagens sao enviadas por ${numero}.`
              : situacao.label
        }
        action={
          numero && !conectada && !andamento.problema ? (
            <Button
              variant="outline"
              disabled={atualizar.isPending}
              onClick={() => atualizar.mutate(unit.id)}
            >
              {atualizar.isPending ? <Spinner /> : <RefreshCw className="h-4 w-4" />}
              Atualizar
            </Button>
          ) : null
        }
      />

      {situacao.setup === 'preparando' ? <WhatsappProgress unit={unit} linha={linha} /> : null}
    </div>
  );
}
